export const MODEL_API_CALL_STARTED = 'MODEL_API_CALL_STARTED';
export const MODEL_API_CALL_COMPLETED = 'MODEL_API_CALL_COMPLETED';
export const MODEL_API_CALL_FAILED = 'MODEL_API_CALL_FAILED'; 
export const RESTART_API_CALL = 'RESTART_API_CALL'